import React, { useState, useEffect } from "react"
import { dataRoomApi } from "../../../api/axiosInstance"
import { Field, useFormikContext } from "formik"
import { Dropdown } from "primereact/dropdown"

// constants
import { GET } from "../../../config/constants"

import styles from "../../../styles/Form.module.css"
import { LoaderSkeleton } from "../../Loaders"

export default function UserFacilityName(props) {
  const [fetching, setFetching] = useState(true)

  const { fieldname, label } = props
  const [userFacilityList, setUserFacilityList] = useState([])

  const { values } = useFormikContext()

  const userState = values?.user_state || ""

  useEffect(() => {
    const fetchData = async () => {
      const result = await dataRoomApi.post(`/${GET.USER_FACILITY_NAME}`, {
        npi_practice_state: userState,
      })
      setUserFacilityList(result.data.options)
      setFetching(false)
    }
    fetchData()
  }, [userState])

  if (fetching) return <LoaderSkeleton count={1} />

  return (
    <Field name={fieldname}>
      {({ field, meta }) => {
        return (
          <div className={styles.field}>
            <label htmlFor={fieldname} className={styles.label}>
              {label}
            </label>
            <Dropdown
              id={fieldname}
              options={userFacilityList}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              disabled={userState === ""}
            />
            {meta.touched && meta.error && (
              <div className={styles.error}>{meta.error}</div>
            )}
          </div>
        )
      }}
    </Field>
  )
}
